<template>
  <div class="p-4">
    <div class="mb-6">
      <p class="font-semibold mb-2">Name</p>
      <el-input
        class="w-full"
        placeholder="Type or Enter"
        disabled
        v-model="editData.firstname"
      />
    </div>

    <div class="mb-6">
      <p class="font-semibold mb-2">Phone</p>
      <el-input
        v-model="editData.mobile"
        class="w-full"
        disabled
        placeholder="Type or Enter"
      />
    </div>

    <div class="mb-6">
      <p class="font-semibold mb-2">Email Address</p>
      <el-input
        v-model="editData.email"
        class="w-full"
        disabled
        placeholder="Type Enter"
      />
    </div>

    <div class="mb-6">
      <p class="font-semibold mb-2">Role</p>
      <el-select
        v-model="editData.role"
        placeholder="Select"
        popper-class="z-index-option"
      >
        <el-option
          v-for="item in roleOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <div class="flex justify-center mt-8">
      <vs-button
        color="primary"
        type="border"
        class="px-10 icon_btnset font-semibold rounded-lg"
        @click="updateUser"
      >
        <!-- <feather-icon icon="PlusIcon" class="mr-1" /> -->
        <span>Add</span>
      </vs-button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      name: "",
      phone: "",
      email: "",
      role: "",
      value2: "",
    };
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    roleOptions() {
      return this.selectedProject.selectedRoles.map((x) => {
        return { value: x.role.toLowerCase(), label: x.role };
      });
    },
  },
  methods: {
    async updateUser() {
      const data = await this.$store.dispatch("manageUser/updateUser", {
        role: this.editData.role,
        id: this.editData._id,
      });
      if (data && data.status == "success") {
        this.$emit("closePopup");
      }
    },
  },
};
</script>
